import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { Agent } from '../../../../../lib/web/core/agent';
import { QueryString } from '../../../../../lib/web/core/query-string';
import { ApiService } from '../../../services/api.service';

@Component({
    selector: '.p-test-player'
})
export class TestPlayerComponent extends ComponentBase<HTMLElement> {

    private _player: any;
    private _playerLsd: any;

    public constructor(node: HTMLElement, private _apiService: ApiService) {
        super(node);       
    }

    public onInit(): void {
        super.onInit();
        this.loadContent();
    }

    private async loadContent(): Promise<void> {
        const id: number = QueryString.get().id || 16;
        const secret: string = QueryString.get().secret || 'f76d2c7b-8f83-47c2-95eb-ca5814f86d27';
        const response: any = await this._apiService.get(`/api/v1/encoding-data/${id}/metadata${secret ? `?secret=${secret}` : ''}`);
        this.loadPlayer(response);
    }

    private loadPlayer(response: any): void {
        console.log(response);

        const videoJsElement: HTMLElement = document.createElement('video-js');        
        videoJsElement.id = 'vjs-player';

        this.loadMedia(videoJsElement, response.media);

        this.node.querySelector('.p-test-player__container').appendChild(videoJsElement);   

        const vjsOptions: any = {
            controls: true,
            //poster: , 
            techOrder: CONFIG.CHROMECAST_APP_ID ? [ 'chromecast', 'html5' ] : undefined,
            chromecast: CONFIG.CHROMECAST_APP_ID ? this.getChromecastConfig() : undefined,
            plugins: {
                chromecast: CONFIG.CHROMECAST_APP_ID ? {
                    receiverAppID: CONFIG.CHROMECAST_APP_ID,
                    addButtonToControlBar: true
                }: undefined
            }          
        };
        this._player = window.videojs('vjs-player', vjsOptions);
    }

    private loadMedia(videoJsElement: HTMLElement, media: any): void {
        const manifest: { type: string, url: string } = this.getManifest(media?.manifests);
        if (manifest) {
            const sourceElement: HTMLSourceElement = document.createElement('source');
            sourceElement.src = manifest.url;
            sourceElement.type = this.getManifestMimeType(manifest.type);
            videoJsElement.appendChild(sourceElement);
        }
    }

    private getManifest(manifests?: { type: string, url: string }[]): { type: string, url: string } {
        if (!manifests?.length) {
            return null;
        }
        const preferredType: string = (Agent.safari() || Agent.iOS()) ? 'hls' : 'dash';
        return manifests.find(m => m.type === preferredType) || manifests[0];
    }

    private getManifestMimeType(type: string): string {
        return type === 'hls' ? 'application/x-mpegURL' : 'application/dash+xml';
    }

    private getChromecastConfig(): any {
        return undefined;
    }
}